import { PersistGate } from 'redux-persist/integration/react'
import { Provider } from "react-redux";
import React from "react";
import { getImageUrl } from './helpers/imageUrl';

import configureStore from "./services/store";
import { bindPersistor } from "./helpers/persistFlush";
import {
	bindDeliveryAuthStore,
	installDeliveryAuthInterceptor,
} from "./services/Delivery/deliveryAuth";
import CheckVersion from "./components/CheckVersion";
import CartHydrator from "./components/CartHydrator";
import InAppNotification from "./components/Mobile/InAppNotification";
import PWAPrompt from "react-ios-pwa-prompt";
import { Offline, Online } from "react-detect-offline";
import OfflineComponent from "./components/Mobile/OfflineComponent";
import CustomCssProvider from "./components/CustomCssProvider";
import PWAInstallation from "./components/Mobile/PWAInstallation";

const polling = {
	enabled: false,
};

const { persistor, store } = configureStore();
bindPersistor(persistor);
bindDeliveryAuthStore(store);
installDeliveryAuthInterceptor();

/** Hold the tree until rehydrate finishes so Home isn't torn down mid-commit. */
const PersistLoading = () => (
	<div
		aria-hidden="true"
		style={{
			minHeight: "100vh",
			width: "100%",
			backgroundColor: "#100E1E",
		}}
	/>
);

const onBeforeLift = () =>
	new Promise((resolve) => {
		// Let the loading placeholder commit before mounting routes (avoids removeChild races).
		requestAnimationFrame(() => resolve());
	});

const Root = ({ children }) => (
	<React.Fragment>
		<Provider store={store}>
			<PersistGate
				loading={<PersistLoading />}
				persistor={persistor}
				onBeforeLift={onBeforeLift}
			>
				<CartHydrator />
				<CustomCssProvider />
				<Online polling={polling}>
					{children}
					<img className="cart-empty-img hidden" style={{ display: "none" }} src={getImageUrl('/assets/img/various/offline.png')} alt="offline" />
					<CheckVersion />
					<InAppNotification />
					<PWAInstallation />
					{localStorage.getItem("enIOSPWAPopup") === "true" && (
						<PWAPrompt
							delay={2500}
							copyTitle={localStorage.getItem("iOSPWAPopupTitle")}
							copyBody={localStorage.getItem("iOSPWAPopupBody")}
							copyShareButtonLabel={localStorage.getItem("iOSPWAPopupShareButtonLabel")}
							copyAddHomeButtonLabel={localStorage.getItem("iOSPWAPopupAddButtonLabel")}
							copyClosePrompt={localStorage.getItem("iOSPWAPopupCloseButtonLabel")}
						/>
					)}
				</Online>
				<Offline polling={polling}>
					<OfflineComponent />
				</Offline>
			</PersistGate>
		</Provider>
	</React.Fragment>
);

export default Root;
